import {
  IDriverStatusFilter,
  INewDriverStatus,
} from "@/features/driver-status/driver-status.types";
import { AxiosResponse } from "axios";
import { http } from "@/utils/http";
import { cleanParams } from "@/utils/cleanParams";

export const driverStatusService = {
  getDriverStatusWatches(filter?: IDriverStatusFilter): Promise<AxiosResponse> {
    return http.get("/driver-status-watches", {
      params: cleanParams(filter),
    });
  },

  createDriverStatusWatch(payload: INewDriverStatus): Promise<AxiosResponse> {
    return http.post("/driver-status-watches", payload);
  },

  cancelDriverStatusWatch(watchId: string): Promise<AxiosResponse> {
    return http.patch(`/driver-status-watches/${watchId}/cancel`, {});
  },

  checkDriverStatusWatch(watchId: string): Promise<AxiosResponse> {
    return http.post(`/driver-status-watches/${watchId}/check`, {});
  },
};
